// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__19PRM","buttons":"SendReceipts_buttons__1l8P0","email":"SendReceipts_email__2oyh-","bookApptTitle":"SendReceipts_bookApptTitle__7cLxI"};